export default __webpack_public_path__ + "static/media/con_body03.1e5d6d9e.jpg";